import { render } from "./BonusDetailContainer.vue?vue&type=template&id=c4035756&scoped=true"
import script from "./BonusDetailContainer.vue?vue&type=script&lang=js"
export * from "./BonusDetailContainer.vue?vue&type=script&lang=js"

import "./BonusDetailContainer.vue?vue&type=style&index=0&id=c4035756&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4035756"]])

export default __exports__